import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import chronoxLogo from "../../../assets/images/global/ChronoxLogoSVG.svg";
import styles from "../../../assets/styles/componentStyles/sideNavigationPanel.module.scss";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Autocomplete, Collapse, Divider, Grid, TextField } from '@mui/material';
import { SidepanelAccountDetails } from '../../utility/sidePanelAccountDetails';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import MiniDrawer from './desktopDrawer';
import globalStyles from "../../../assets/styles/global.module.scss";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import IconsColor from '../../utility/iconsColor';
import { getOrganizationDetailDataModel } from '../../../models/axiosModel';
import { DelegateAccess } from '../../global/delegateAccess';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import BackToMainPageGlobalComponent from '../../utility/backToMainPageGlobalComponent';
import { flagShowGetStartedPage, getMenuNameOfMainMenu, isGetStartedPageActive, isStagingEnv, showWorkspaceBlock, sideNavigationNavigateToHomeBlockedRoutes, sidePanelWidth } from '../../../utils/constants';
import { getSideNavigationPanelMaxHeightClassName, isNewTabClick } from './constant';
import { getVendorField } from '../../../utils/whiteLabelling'; 
import { primaryColor } from '../../../utils/colors';

const mobileDrawerWidth = 96;
interface menuItem {
    menuName: string,
    menuKey: string,
    imgSrc: any,
    whiteImgSrc: any,
    coloredImgSrc: any,
    navigationLink: string,
    flagDisabled?: boolean
    subMenu?: [],
    flagHeaderKey?: boolean,
    flagAdmin?: boolean
}
interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window?: () => Window;
    open: boolean;
    onClose: () => void;
    menuItems: menuItem[]
    handleDrawerOpen: () => void;
    handleDrawerClose: () => void;
    openDesktopDrawer: boolean
}
export default function SideNavigationPanel(props: Props) {
    const { userDetail, organizationDetails, currentActiveMobileMenu, setCurrentActiveMobileMenu, customPagesData, selectedSubMenu, setSelectedSubMenu, currentMenuName, flagHideConsultation, vendorData } = React.useContext(UserContext) as UserContextPayload
    const [hoveredMenu, setHoveredMenu] = React.useState("");
    const [openSubMenu, setOpenSubMenu] = React.useState(true);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const chatbot_id = searchParams.get("chatbot_id");
    const id = searchParams.get("id");
    const agentId = searchParams.get("voice_agent_id");
    const organization_id = searchParams.get('organization_id');
    const pathName = window.location.pathname.toLowerCase()

    React.useEffect(() => {
        // Tim Safransky's Organization ID
        // userDetail?.user_organization_data?.organization_id != 2582
        if (window.location.pathname == "/" && userDetail?.user_organization_data?.organization_id != 2645) {
            // setCurrentActiveMobileMenu("/whatsappcampaign")  
            if(flagShowGetStartedPage(userDetail)){
                setCurrentActiveMobileMenu("/get-started")
            } else {
                setCurrentActiveMobileMenu("/dashboard")
            }
        }
        else if (window.location.pathname == "/" && userDetail?.user_organization_data?.organization_id == 2645) {  //activemenu for aapdujunagadh
            setCurrentActiveMobileMenu("/channels")
        }
        // else if (window.location.pathname == "/" && userDetail?.user_organization_data?.organization_id == 2582) {  //activemenu for timsafransky
        //     setCurrentActiveMobileMenu("/callanalysis")
        // }
        else if (window.location.pathname.toLowerCase() == "/createchatbot" || window.location.pathname == "/chatbot") {
            setCurrentActiveMobileMenu("/chatbot")
        }
        else if (window.location.pathname.toLowerCase() == "/dashboard") {
            setCurrentActiveMobileMenu("/dashboard");
        }
         else if (window.location.pathname.toLowerCase() == "/get-started") {
            setCurrentActiveMobileMenu("/get-started");
        }
        else if (window.location.pathname == "/insights") {
            setCurrentActiveMobileMenu("/insights")
        }
        else if (window.location.pathname.toLowerCase() == "/inbox") {
            setCurrentActiveMobileMenu(`/inbox`)
        }
        else if (window.location.pathname.toLowerCase() == "/voiceagent") {
            setCurrentActiveMobileMenu(`/voiceagent`)
        }
        else if (window.location.pathname.toLowerCase() == "/voiceagent/createvoiceagent") {
            setCurrentActiveMobileMenu(agentId ? `/voiceagent/createvoiceagent?voice_agent_id=${agentId}` : `/voiceagent/createvoiceagent`)
        }
        else if (window.location.pathname.toLowerCase() == "/voiceagent/createvoiceagent/deployments") {
            setCurrentActiveMobileMenu(agentId ? `/voiceagent/createvoiceagent/deployments?voice_agent_id=${agentId}` : `/voiceagent/createvoiceagent/deployments`)
        }
        else if (window.location.pathname.toLowerCase() == "/voiceagent/createvoiceagent/customapi") {
            setCurrentActiveMobileMenu(agentId ? `/voiceagent/createvoiceagent/customapi?voice_agent_id=${agentId}` : `/voiceagent/createvoiceagent/customapi`)
        }
        else if (window.location.pathname.toLowerCase() == "/supportticket") {
            setCurrentActiveMobileMenu(`/supportTicket`)
        }
        else if (window.location.pathname.toLowerCase() == "/contacts") {
            setCurrentActiveMobileMenu(`/contacts`)
        }
        else if (window.location.pathname.toLowerCase() == "/channels") {
            setCurrentActiveMobileMenu(`/channels`)
        }
        else if (window.location.pathname.toLowerCase() == "/whatsappcampaign" || window.location.pathname.toLowerCase() === "/whatsappcampaign/createnewcampaign") {
            setCurrentActiveMobileMenu(`/whatsappcampaign`)
        }
        else if (window.location.pathname.toLowerCase() == "/whatsappcampaign/dashboard") {
            setCurrentActiveMobileMenu(`/whatsappcampaign/dashboard`)
        }
        else if (window.location.pathname.toLowerCase() == "/product") {
            setCurrentActiveMobileMenu(`/product`)
        }
        else if (window.location.pathname.toLowerCase() == "/knowledge-base") {
            setCurrentActiveMobileMenu(`/knowledge-base`);
        }
        else if (window.location.pathname.toLowerCase() == "/workflow" || window.location.pathname.toLowerCase() === "/workflow/staticworkflowdetails") {
            setCurrentActiveMobileMenu(`/workflow`);
        }
        else if (window.location.pathname.toLowerCase() == "/customapi" || window.location.pathname.toLowerCase() == "/customapi/createcustomapi") {
            setCurrentActiveMobileMenu(`/customAPI`);
        } 
        else if (window.location.pathname.toLowerCase() == "/webhook"){
            setCurrentActiveMobileMenu(`/Webhook`);
        }
        else if (window.location.pathname.toLowerCase() == "/orderdetails"){
            setCurrentActiveMobileMenu(`/orderDetails`);
        }
        else if (window.location.pathname.toLowerCase() == "/conversionleads"){
            setCurrentActiveMobileMenu(`/conversionLeads`);
        }
        else if (window.location.pathname.toLowerCase() == "/intent"){
            setCurrentActiveMobileMenu(`/intent`);
        }
        else if (window.location.pathname.toLowerCase() == "/settings-plansandbilling") {
            setCurrentActiveMobileMenu("/settings-accountDetails")
        }
        else if (window.location.pathname.toLowerCase() == "/settings-accountdetails") {
            setCurrentActiveMobileMenu("/settings-accountDetails")
        }
        else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/basicdetail" || window.location.pathname.toLowerCase() == "/chatbot/viewchatbot") {
            setCurrentActiveMobileMenu(`/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/integration" || window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/createintegration") {
            setCurrentActiveMobileMenu(`/chatbot/viewchatbot/integration?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/subaichatbot") {
            setCurrentActiveMobileMenu(`/chatbot/viewchatbot/subaichatbot?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/persistentmenu") {
            setCurrentActiveMobileMenu(`/chatbot/viewchatbot/persistentmenu?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/channels/whatsapp" || window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/channels/viewwhatsappintegration") {
            setOpenSubMenu(true)
            setCurrentActiveMobileMenu(`/chatbot/viewchatbot/channels/whatsapp?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/channels/facebook" || window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/channels/viewfacebookintegration") {
            setOpenSubMenu(true)
            setCurrentActiveMobileMenu(`/chatbot/viewchatbot/channels/facebook?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/channels/instagram" || window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/channels/viewinstagramintegration") {
            setOpenSubMenu(true)
            setCurrentActiveMobileMenu(`/chatbot/viewchatbot/channels/instagram?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/channels/website") {
            setOpenSubMenu(true);
            setCurrentActiveMobileMenu(`/chatbot/viewchatbot/channels/website?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase().includes("/chatbot/viewchatbot/channels/calendly")) {
            setOpenSubMenu(true);
            setCurrentActiveMobileMenu(`/chatbot/viewchatbot/channels/calendly?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase().includes("/chatbot/viewchatbot/channels/slack")) {
            setOpenSubMenu(true);
            setCurrentActiveMobileMenu(`/chatbot/viewchatbot/channels/slack?chatbot_id=${chatbot_id}`)
        }
        // else if (window.location.pathname.toLowerCase().includes("/chatbot/viewchatbot/channels/zoho")) {
        //     setOpenSubMenu(true);
        //     setCurrentActiveMobileMenu(`/chatbot/viewchatbot/channels/zoho?chatbot_id=${chatbot_id}`)
        // }
        else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/inbox") {
            setCurrentActiveMobileMenu(`/chatbot/viewchatbot/inbox?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase().includes("/chatbot/viewchatbot/leadgeneration")) {
            setCurrentActiveMobileMenu(`/chatbot/viewchatbot/leadgeneration?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/products") {
            setCurrentActiveMobileMenu(`/chatbot/viewchatbot/products?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/messageformat" || window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/messageformat/staticformat") {
            setCurrentActiveMobileMenu(`/chatbot/viewchatbot/messageformat?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/trychatbot") {
            setCurrentActiveMobileMenu(`/chatbot/viewchatbot/trychatbot?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() == "/channels/viewintegration/whatsapp") {
            setOpenSubMenu(true);
            id ? setCurrentActiveMobileMenu(`/channels/viewintegration/whatsapp?id=${id}`) : setCurrentActiveMobileMenu(`/channels/viewintegration/whatsapp`)
        }
        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/flows" || window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/flowdetails") {
            setOpenSubMenu(true);
            id ? setCurrentActiveMobileMenu(`/channels/viewintegration/whatsapp/flows?id=${id}`) : setCurrentActiveMobileMenu(`/channels/viewintegration/whatsapp/flows`)
        }
        else if(window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/paymentconfiguration"){
            setOpenSubMenu(true);
            id ? setCurrentActiveMobileMenu(`/channels/viewintegration/whatsapp/paymentconfiguration?id=${id}`) : setCurrentActiveMobileMenu(`/channels/viewintegration/whatsapp/paymentconfiguration`)
        }
        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/carouseltemplategroups") {
            setOpenSubMenu(true);
            id ? setCurrentActiveMobileMenu(`/channels/viewintegration/whatsapp/templatemessages?id=${id}`) : setCurrentActiveMobileMenu(`/channels/viewintegration/whatsapp/templatemessages`)
        }
        else if (window.location.pathname.toLowerCase() == "/channels/viewintegration/whatsapp/phonenumbers" || window.location.pathname.toLowerCase() == "/channels/viewintegration/whatsapp/phonenumbers/customrecipient") {
            id ? setCurrentActiveMobileMenu(`/channels/viewintegration/whatsapp/phonenumbers?id=${id}`) : setCurrentActiveMobileMenu(`/channels/viewintegration/whatsapp/phonenumbers`)
        }
        else if (window.location.pathname.toLowerCase() == "/channels/viewintegration/whatsapp/legacy/templateinfo" || window.location.pathname.toLowerCase() == "/channels/viewintegration/whatsapp/templatemessages") {
            id ? setCurrentActiveMobileMenu(`/channels/viewintegration/whatsapp/templatemessages?id=${id}`) : setCurrentActiveMobileMenu(`/channels/viewintegration/whatsapp/templatemessages`)
        }
        else if (window.location.pathname.toLowerCase().startsWith("/channels/viewintegration/whatsapp/templatelibrary")) {
            id ? setCurrentActiveMobileMenu(`/channels/viewintegration/whatsapp/templatemessages?id=${id}`) : setCurrentActiveMobileMenu(`/channels/viewintegration/whatsapp/templatemessages`)
        }
        else if (window.location.pathname.toLowerCase() == "/channels/viewintegration/facebook") {
            setOpenSubMenu(true);
            id ? setCurrentActiveMobileMenu(`/channels/viewintegration/facebook?id=${id}`) : setCurrentActiveMobileMenu(`/channels/viewintegration/facebook`)
        }
        else if (window.location.pathname.toLowerCase() == "/channels/viewintegration/facebook/pages") {
            id ? setCurrentActiveMobileMenu(`/channels/viewintegration/facebook/pages?id=${id}`) : setCurrentActiveMobileMenu(`/channels/viewintegration/facebook/pages`)
        }
        else if (window.location.pathname.toLowerCase() == "/channels/viewintegration/facebook/templateinfo" || window.location.pathname.toLowerCase() == "/channels/viewintegration/facebook/templatemessages") {
            id ? setCurrentActiveMobileMenu(`/channels/viewintegration/facebook/templatemessages?id=${id}`) : setCurrentActiveMobileMenu(`/channels/viewintegration/facebook/templatemessages`)
        }
        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/instagram") {
            id ? setCurrentActiveMobileMenu(`/channels/viewintegration/instagram?id=${id}`) : setCurrentActiveMobileMenu(`/channels/viewintegration/instagram`)
        }
        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/slack") {
            id ? setCurrentActiveMobileMenu(`/channels/viewintegration/slack?id=${id}`) : setCurrentActiveMobileMenu(`/channels/viewintegration/slack`)
        }
        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/slack/channels") {
            id ? setCurrentActiveMobileMenu(`/channels/viewintegration/slack/channels?id=${id}`) : setCurrentActiveMobileMenu(`/channels/viewintegration/slack/channels`)
        }
        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/zoho") {
            id ? setCurrentActiveMobileMenu(`/channels/viewintegration/zoho?id=${id}`) : setCurrentActiveMobileMenu(`/channels/viewintegration/zoho`)
        }
        else if (window.location.pathname.toLowerCase() === "/organization") {
            organization_id ? setCurrentActiveMobileMenu(`/organization?organization_id=${organization_id}`) : setCurrentActiveMobileMenu(`/organization`)
        }
        else if (window.location.pathname.toLowerCase() === "/organization/ticketsubstatus") {
            organization_id ? setCurrentActiveMobileMenu(`/organization/ticketsubstatus?organization_id=${organization_id}`) : setCurrentActiveMobileMenu(`/organization`)
        }
        else if (window.location.pathname.toLowerCase() === "/organization/teams") {
            organization_id ? setCurrentActiveMobileMenu(`/organization/teams?organization_id=${organization_id}`) : setCurrentActiveMobileMenu(`/organization/teams`)
        }
        else if(window.location.pathname.toLowerCase() === "/apiKeys"){
            setCurrentActiveMobileMenu("/apiKeys");
        }
        else if (window.location.pathname.toLowerCase() === "/billing-usage" || window.location.pathname.toLowerCase() === "/plans") {
            setCurrentActiveMobileMenu("/billing-usage");
        }
        else if (window.location.pathname.toLowerCase() === "/callanalysis/callrecords") {
            setOpenSubMenu(true)
            setCurrentActiveMobileMenu(`/callanalysis`)
        }
        else if (window.location.pathname.toLowerCase() === "/callanalysis/callrecords/newcallrecords") {
            setOpenSubMenu(true)
            setCurrentActiveMobileMenu(`/callanalysis`)
        }
        else if (window.location.pathname.toLowerCase() === "/callanalysis") {
            setOpenSubMenu(true)
            setCurrentActiveMobileMenu(`/callanalysis`)
        }
        else if (window.location.pathname.toLowerCase() === "/analytics") {
            setCurrentActiveMobileMenu(`/analytics`)
        }
        else if (customPagesData && customPagesData?.length > 0 && customPagesData?.find((pages) => pages.custom_page_slug == window.location.pathname)) {
            setOpenSubMenu(true);
            setCurrentActiveMobileMenu(customPagesData?.find((pages) => pages.custom_page_slug == window.location.pathname)?.custom_page_slug || "")
        }
        else {
            setCurrentActiveMobileMenu(window.location.pathname.toLowerCase())
        }
    }, [window.location.pathname])


    const handleClick = (keyName: string) => {
        if (!selectedSubMenu.includes(keyName)) {
            setSelectedSubMenu([...selectedSubMenu, keyName]);
        }
        else if (selectedSubMenu.includes(keyName)) {
            setSelectedSubMenu([...selectedSubMenu.filter((data) => data !== keyName)])
        }
        if (window.location.pathname.toLowerCase() === `/chatbot/viewchatbot/channels/website` || window.location.pathname.toLowerCase().includes('/chatbot/viewchatbot/channels/calendly') || window.location.pathname.toLowerCase() === `/chatbot/viewchatbot/channels/whatsapp` || window.location.pathname.toLowerCase() === `/chatbot/viewchatbot/channels/facebook` || window.location.pathname.toLowerCase() === `/chatbot/viewchatbot/channels/instagram` || window.location.pathname.toLowerCase() === `/chatbot/viewchatbot/channels/viewwhatsappintegration` || window.location.pathname.toLowerCase() === `/chatbot/viewchatbot/channels/viewfacebookintegration` || window.location.pathname.toLowerCase() === `/chatbot/viewchatbot/channels/viewinstagramintegration`) {
            setOpenSubMenu(true);
        }
        else if (window.location.pathname.toLowerCase() === `/callanalysis` || window.location.pathname.toLowerCase() === `/callanalysis/callrecords`) {
            setOpenSubMenu(true);
        }
        else if (customPagesData && customPagesData.length > 0 && customPagesData.filter((data) => data.custom_page_slug == currentActiveMobileMenu).length > 0) {
            setOpenSubMenu(true);
        }
        else if (window.location.pathname.toLowerCase() === `/channels/viewintegration` || window.location.pathname.toLowerCase() === `/channels/viewintegration/templateinfo` || window.location.pathname.toLowerCase() === `/channels/viewintegration/templatemessages`) {
            setOpenSubMenu(true)
        }
        else {
            // setOpenSubMenu(!openSubMenu);
        }
    };

    const onClickOfGetStartedBlock = () => {
        navigate("/get-started"); 
        props.onClose();
    }

    const drawer = (
        <>
            <Grid container className={`${styles.mobiledrawerContainer} ${getSideNavigationPanelMaxHeightClassName(pathName, userDetail, 'mobile')} ${styles.navigationPanelContentWrapper}`}>
                <Grid item>

                    <div className={styles.mobileDrawerHeaderContainer}>
                        <Toolbar>
                            <a
                                href="/"
                                className={`${styles.navigationLink} ${styles.logoLink}`}
                                onClick={(event) => {
                                    if (isNewTabClick(event)) return;
                                    event.preventDefault();
                                    navigate('/');
                                    props?.onClose();
                                }}
                            >
                                <img alt="logo" src={getVendorField(vendorData, "company primary logo", chronoxLogo)} className={styles.writewizLogoStyle} />
                            </a>
                        </Toolbar>

                        {isStagingEnv() && (
                            <span className={styles.devBadge}>
                                Dev
                            </span>
                        )}
                    </div>

                    {flagShowGetStartedPage(userDetail) &&
                        <>
                            <Grid item
                                component="a"
                                href="/get-started"
                                className={`${isGetStartedPageActive() ? styles.getStartedPageBlockWithActivePage : styles.getStartedPageBlockWithoutActive} ${globalStyles.clickable} ${styles.navigationLink}`}
                                onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                                    if (isNewTabClick(event)) return;
                                    event.preventDefault();
                                    onClickOfGetStartedBlock();
                                }}
                            >
                                <Grid container className={styles.getStartedPageBlockContainer}>
                                    <Grid item className={globalStyles.displayFlexStyle}>
                                        <IconsColor iconName="getStartedPageIcon" height={21} width={20} fillColor={primaryColor} />
                                    </Grid>
                                    <Grid item className={styles.getStartedPgaeText}>Get Started</Grid>
                                </Grid>
                            </Grid>
                            <Divider className={styles.desktopDrawerDivider} />
                        </>
                    }
                    <List className={styles.mobileDrawerPadding}  >
                        {props.menuItems.map((menuItem, index) => {
                            return (
                                <React.Fragment key={index}>
                                    {!menuItem.subMenu ?
                                        <ListItem
                                            component="a"
                                            // Only real destinations get an href (disabled items and plain headers stay non-links)
                                            href={!menuItem.flagDisabled && (!menuItem.flagHeaderKey || menuItem?.menuName?.toLowerCase() == "get started") ? menuItem.navigationLink : undefined}
                                            sx={{ opacity: menuItem.flagDisabled ? "0.5" : "1" }}
                                            className={`${menuItem.flagHeaderKey ? styles.headerSideItem : (currentActiveMobileMenu.toLowerCase() == menuItem.navigationLink.toLowerCase()) ? styles.selectedListItemStyle : styles.listItemStyle} ${styles.navigationLink}`}
                                            onMouseEnter={() => { setHoveredMenu(menuItem.menuKey) }} onMouseLeave={() => { setHoveredMenu("") }}
                                            onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                                                if (isNewTabClick(event)) return;
                                                event.preventDefault();
                                                if (menuItem.flagDisabled) {
                                                } else if (menuItem.flagHeaderKey) {
                                                    // setOpenSubMenu(false); 
                                                    if(menuItem?.menuName?.toLowerCase() == "get started"){
                                                        setCurrentActiveMobileMenu(menuItem.navigationLink)
                                                        navigate(menuItem.navigationLink)
                                                        setSelectedSubMenu([])
                                                        props.onClose()
                                                    }
                                                } else {
                                                    setCurrentActiveMobileMenu(menuItem.navigationLink);
                                                    // setOpenSubMenu(false);
                                                    setSelectedSubMenu([])
                                                    navigate(menuItem.navigationLink)
                                                    props.onClose()
                                                }
                                            }
                                            } disablePadding>
                                            <ListItemIcon className={`${styles.imageNavigationMenu} ${styles.scaledSmall}`}>
                                                {currentActiveMobileMenu.toLowerCase() == menuItem.navigationLink.toLowerCase() ? menuItem.whiteImgSrc : hoveredMenu.toLowerCase() == menuItem.menuKey.toLowerCase() ? menuItem.coloredImgSrc : menuItem.imgSrc}
                                            </ListItemIcon>
                                            <ListItemText primary={menuItem.menuName} className={currentActiveMobileMenu.toLowerCase() == menuItem.navigationLink.toLowerCase() || menuItem.flagDisabled || menuItem.flagHeaderKey ? styles.listItemSelectedMenuText : styles.listItemMenuText} />
                                            {menuItem.flagAdmin &&
                                                <AdminPanelSettingsIcon />
                                            }

                                        </ListItem>
                                        :
                                        <>
                                            <ListItem button onClick={() => handleClick(menuItem.menuKey)} className={currentMenuName == menuItem.menuKey && !selectedSubMenu.includes(menuItem.menuKey) ? styles.selectedListItemStyle : styles.listItemStyle}>
                                                {menuItem.menuName?.toLowerCase() != "show more/less" ?
                                                    <ListItemIcon className={`${styles.imageNavigationMenu} ${styles.scaledLarge}`}>
                                                        {menuItem.imgSrc}
                                                    </ListItemIcon>
                                                    :
                                                    <ListItemIcon className={`${styles.imageNavigationMenu}`}>
                                                        {openSubMenu && selectedSubMenu.includes(menuItem.menuKey) ? <ExpandLess sx={{ marginLeft: "-4px", color: "#4C4A4D" }} /> : <ExpandMore sx={{ marginLeft: "-4px", color: "#4C4A4D" }} />}        
                                                    </ListItemIcon>
                                                }
                                                <ListItemText primary={getMenuNameOfMainMenu(menuItem.menuName, openSubMenu && selectedSubMenu.includes(menuItem.menuKey))} />
                                                {menuItem.menuName?.toLowerCase() != "show more/less" && 
                                                    <>
                                                        {openSubMenu && selectedSubMenu.includes(menuItem.menuKey) ? <ExpandLess /> : <ExpandMore />}
                                                    </>
                                                }
                                            </ListItem>
                                            <Collapse in={openSubMenu && selectedSubMenu.includes(menuItem.menuKey)} timeout="auto" unmountOnExit>
                                                <List component="div" disablePadding>
                                                    {/* Nested items */}
                                                    {menuItem.subMenu.map((subMenu: any, ind: number) => {
                                                        return <ListItem
                                                            component="a"
                                                            href={!subMenu.flagDisabled && !subMenu.flagUserSpecific ? subMenu.navigationLink : undefined}
                                                            sx={{ opacity: menuItem.flagDisabled ? "0.5" : "1", paddingLeft: "20px !important" }}
                                                            className={`${currentActiveMobileMenu.toLowerCase() == subMenu.navigationLink.toLowerCase() ? styles.selectedListItemStyle : styles.listItemStyle} ${styles.navigationLink}`}
                                                            onMouseEnter={() => { setHoveredMenu(menuItem.menuKey) }}
                                                            onMouseLeave={() => { setHoveredMenu("") }}
                                                            onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                                                                if (isNewTabClick(event)) return;
                                                                event.preventDefault();
                                                                if (!subMenu.flagDisabled) {
                                                                    setCurrentActiveMobileMenu(subMenu.navigationLink);
                                                                    if (!subMenu.flagUserSpecific) {
                                                                        navigate(subMenu.navigationLink);
                                                                    }
                                                                    props.onClose();
                                                                }
                                                            }}
                                                            key={ind + index}
                                                            disablePadding
                                                        >
                                                            <ListItemIcon className={`${styles.imageNavigationMenu} ${styles.scaledLarge}`}>
                                                                {currentActiveMobileMenu.toLowerCase() == subMenu.navigationLink.toLowerCase() ? subMenu.whiteImgSrc : hoveredMenu.toLowerCase() == subMenu.menuKey.toLowerCase() ? subMenu.coloredImgSrc : subMenu.imgSrc}
                                                            </ListItemIcon>
                                                            <ListItemText primary={subMenu.menuName} className={currentActiveMobileMenu.toLowerCase() == subMenu.navigationLink.toLowerCase() || menuItem.flagDisabled || menuItem.flagHeaderKey ? styles.listItemSelectedMenuText : styles.listItemMenuText} />
                                                            {subMenu.flagAdmin && <AdminPanelSettingsIcon />}

                                                        </ListItem>
                                                    })
                                                    }
                                                </List>
                                            </Collapse>
                                        </>
                                    }
                                </React.Fragment>
                            )
                        })}
                    </List>
                </Grid>
                <Grid item>
                    <Grid container direction={"column"}>
                        {
                            <Grid item className={`${styles.profileWrapper}`} onClick={() => props.onClose()}>
                                <DelegateAccess />
                            </Grid>
                        }
                        {/* <Grid item className={styles.settingsWorkspace} >
                            <SettingsWorkspace onclose={() => props.onClose()} flagMobileScreen />
                        </Grid> */}

                        {!sideNavigationNavigateToHomeBlockedRoutes(window.location.pathname) &&
                            // flagShowHomeButton() &&
                            <Grid item className={styles.settingsWorkspace} onClick={() => props?.onClose()}>
                                <BackToMainPageGlobalComponent onclose={() => props.onClose()} />
                            </Grid>
                        }
                        {/* {!userDetail.flag_user_anonymous &&
                            userDetail.flagUser &&
                            <Grid item className={`${styles.profileWrapper}`} onClick={() => props.onClose()}>
                                <ConsultationComponent flagInsideSideNavigationPanel />
                            </Grid>
                        } */} 

                        {
                            showWorkspaceBlock(pathName) &&
                            <>
                                <Grid item className={styles.workspaceWrapper}>
                                    <Grid container className={styles.workspaceContainer}  >
                                        <Grid item>
                                            <Grid container className={`${styles.workspaceTextContainer} ${styles.workspaceTextGap}`}>
                                                <Grid item><IconsColor height={"15"} width={"15"} fillColor={"#4C4A4D"} iconName="workspace" /></Grid>
                                                <Grid item className={styles.workspaceText} ><span>Workspace</span></Grid>
                                            </Grid>
                                        </Grid>
                                        {organizationDetails && organizationDetails.length > 1 ?
                                            <Autocomplete
                                                disableClearable
                                                value={organizationDetails ? organizationDetails.find((organization) => organization.organization_status_name === "Active") : undefined}
                                                className={`${globalStyles.chatbotTitleSelect}`}
                                                options={organizationDetails ? organizationDetails : []}
                                                getOptionLabel={(option: getOrganizationDetailDataModel) => option.organization_name}
                                                renderInput={(params) => <TextField
                                                    {...params} placeholder='Select' />}
                                            />
                                            :
                                            <Grid item className={styles.organizationName}>
                                                {organizationDetails ? organizationDetails[0].organization_name : ""}
                                            </Grid>}
                                    </Grid>
                                </Grid>
                                {/* {!props.menuItems.find((menu: any) => (!menu?.subMenu && menu?.flagHeaderKey)) && 
                                    <Divider className={styles.workspaceDivider} />
                                } */}
                            </>
                        }

                        <Grid item className={` ${styles.AccountDetailsWrapper}`}>
                            <SidepanelAccountDetails onClose={() => props?.onClose()} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
    return (
        <Box sx={{ display: 'flex' }}>
            <Box
                component="nav"
                sx={{ width: { sm: props.open ? sidePanelWidth : mobileDrawerWidth }, flexShrink: { sm: 0 } }}
                aria-label="mailbox folders"
                className={styles.sideBarIcon}
            >
                {/* mobile drawer */}
                <Drawer
                    className={styles.sideNavigationPanelStyle}
                    variant="temporary"
                    open={props.open}
                    onClose={() => props?.onClose()}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: sidePanelWidth, overflow: "hidden" },
                    }}
                >
                    {drawer}
                </Drawer>

                <MiniDrawer
                    menuItems={props.menuItems}
                    open={props.openDesktopDrawer}
                    handleDrawerClose={props.handleDrawerClose}
                    handleDrawerOpen={props.handleDrawerOpen}
                />
            </Box>
        </Box>
    );
}